/**
 * @author Fernando Ruano
 * @file constants.js
 * @description S3 File Constants
 */

// Generic actions
export const GET_ALL_S3_FILES = 'S3/GET_ALL_S3_FILES';
export const GET_S3_FILE_BY_KEY = 'S3/GET_S3_FILE_BY_KEY';
export const UPLOAD_S3_FILE = 'S3/UPLOAD_S3_FILE';
export const DELETE_S3_FILE_BY_KEY = 'S3/DELETE_S3_FILE_BY_KEY';
